<div class="alert_">
    <div>{{'add_note_success' | translate}}</div>
    <div class="next"><a [routerLink]="['/my-account/add-note']" >{{'add_note_next' | translate}}</a></div>
</div>